import * as Yup from "yup";
import { EMAIL_REGEX, WHITE_SPACES_REGEX } from "../constants";

export const forgotPasswordEmailFieldNames = {
  EMAIL: "email",
};

export const forgotPasswordEmailInitialValues = {
  [forgotPasswordEmailFieldNames.EMAIL]: "",
};

export const forgotPasswordEmailValidationSchema = (intl) =>
  Yup.object().shape({
    [forgotPasswordEmailFieldNames.EMAIL]: Yup.string()
      .required(intl.formatMessage({ id: "login.fieldError.email.required" }))
      .email(intl.formatMessage({ id: "login.fieldError.email.invalid" }))
      .matches(
        EMAIL_REGEX,
        intl.formatMessage({ id: "login.fieldError.email.invalid" })
      )
      .matches(
        WHITE_SPACES_REGEX,
        intl.formatMessage({ id: "login.fieldError.email.invalid" })
      ),
  });
